import { statusLevels } from "@/mocks/evidence";
import Reveal from "./Reveal";
import { SectionHeading } from "./Ui";

const toneCard: Record<string, string> = {
  red: "border-primary-200 bg-primary-50",
  amber: "border-accent-200 bg-accent-50",
  gray: "border-secondary-200 bg-secondary-50",
  line: "border-foreground-200 bg-background-100",
};
const toneIcon: Record<string, string> = {
  red: "ri-shield-check-line text-primary-600",
  amber: "ri-search-eye-line text-accent-700",
  gray: "ri-question-line text-secondary-600",
  line: "ri-loop-left-line text-foreground-600",
};

const steps = [
  { n: "01", t: "来源收集", d: "固定可追溯出处，去除无法溯源的二手转述。" },
  { n: "02", t: "交叉核验", d: "以截图、录音、视频多源比对，标记一致与冲突。" },
  { n: "03", t: "分档标注", d: "按证据链完整度归入石锤、实锤、存疑三档。" },
  { n: "04", t: "持续复核", d: "出现新证据或口径反转时，重新标记并公开说明。" },
];

export default function Standard() {
  return (
    <section id="standard" className="bg-background-100">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="Verification · 核验标准"
          title="石锤 / 实锤 / 存疑，是怎么界定的？"
          desc="为避免结论含混，本站把所有归档材料按证据链完整度分档标注。同一条材料的结论可随新证据追加与复核而调整。"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {statusLevels.map((lvl, idx) => (
            <Reveal key={lvl.key} delay={idx * 80}>
              <div
                className={`flex h-full flex-col rounded-lg border p-5 ${toneCard[lvl.tone]}`}
              >
                <div className="flex items-center justify-between">
                  <span
                    className={`flex h-10 w-10 items-center justify-center rounded-md bg-background-50`}
                  >
                    <i
                      className={`${toneIcon[lvl.tone]} flex h-5 w-5 items-center justify-center text-xl`}
                    />
                  </span>
                  <span className="text-3xl font-heading font-semibold text-foreground-950">
                    {lvl.name}
                  </span>
                </div>
                <p className="mt-3 text-xs leading-relaxed text-foreground-700 md:text-sm">
                  {lvl.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          {steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 90}>
              <div className="relative h-full rounded-lg border border-background-200 bg-background-50 p-5">
                <div className="flex items-center gap-3">
                  <span className="font-heading text-2xl font-bold text-primary-200">
                    {s.n}
                  </span>
                  <h3 className="font-heading text-base font-semibold text-foreground-950">
                    {s.t}
                  </h3>
                </div>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600">
                  {s.d}
                </p>
                {i < steps.length - 1 && (
                  <i className="ri-arrow-right-line absolute right-4 top-5 hidden text-xl text-primary-300 lg:block" />
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}